// @flow

import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import WithAuth from '../../../../hocs/auth';
import { modalInstance } from './../../Content';
import ChangePasswordModal from './../../modal/ChangePasswordModal';
import GhostButton from './../../../../components/GhostButton';
import ContactInfo from './contactInfo/ContactInfo';
import ManualTab from './manualTab/ManualTab';
import LabelSettings from './labelSettings/LabelSettings';
import { clearProject } from './../../../../actions/auth';
import { setChosenFlight } from './../../../../actions/flightManager';
import UserLanguageChanger from './UserLanguageChanger';

const StyledWrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  height: 100%;
`;

const SettingWrapper = styled.div`
    flex-shrink: 0;
    border: 2px solid #265a9c;
    border-radius: 0 5px 5px 5px;
    background-color: #ffffff;
    padding: 0px;
    width: calc(100% - 2px);
    margin-left: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
`;

export const SettingsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  p{
    margin: 5px;
    width: 100%;
  }
`;

class User extends React.Component {
    customizeModalWindow() {
        const { t } = this.props;
        const config = {
            title: t('Enter new password'),
            content: <ChangePasswordModal changePasswordCallback={this.changePasswordCallback} />,
            closeOnConfirm: false,
            confirmBtnVisible: false,
            cancelBtnVisible: false,
            confirmBtnText: t('Change password'),
            cancelBtnText: t('Close'),
        }
        modalInstance.customize(config);
    }

    changePasswordCallback() {
        modalInstance.close();
    }

    render() {
        const { t } = this.props;
        return (
            <StyledWrapper>
                <Tabs style={{
                    width: 'calc(100% - 10px)',
                    marginLeft: '-2px',
                }}>
                    <TabList className={'settings_tab_list'}>
                        <Tab>{t('User')}</Tab>
                        <Tab>{t('Labels')}</Tab>
                        <Tab>{t('Contact')}</Tab>
                        <Tab>{t('Manual')}</Tab>
                    </TabList>
                    <SettingWrapper>
                        <TabPanel>
                            <div
                                style={{
                                    padding: '5px',
                                }}
                            >
                                <SettingsRow>
                                    <p>
                                        {t('User')}: &nbsp; <b>{this.props.userName}</b>
                                    </p>
                                    <p>
                                        Email: &nbsp; <b>{this.props.userEmail}</b>
                                    </p>
                                </SettingsRow>
                                <SettingsRow>
                                    <p>
                                        {t('Manage your account')}:
                                    </p>
                                    <GhostButton
                                        style={{
                                            margin: '0 5px 0 0',
                                            padding: '5px',
                                            height: '20px',
                                        }}
                                        onClick={
                                            () => {
                                                this.customizeModalWindow(this.props.t);
                                                modalInstance.show();
                                            }
                                        }>
                                        {this.props.t('Change password')}
                                    </GhostButton>
                                    <GhostButton
                                        style={{
                                            padding: '5px',
                                            height: '20px',
                                        }}
                                        onClick={() => this.props.signOut()}>
                                        {this.props.t('SignOut')}
                                    </GhostButton>
                                </SettingsRow>
                                <UserLanguageChanger translator={this.props.t}/>
                                <SettingsRow>
                                    <p>
                                        {t('Change project')}:
                                    </p>
                                    <GhostButton
                                        style={{
                                            height: '30px',
                                            marginLeft: '5px',
                                            marginRight: '5px',
                                        }}
                                        onClick={() => {
                                            this.props.setChosenFlight(null);
                                            this.props.clearProject()
                                        }}
                                    >
                                        {t('Projects')}
                                    </GhostButton>
                                </SettingsRow>
                            </div>
                        </TabPanel>
                        <TabPanel
                            style={{
                                width: '100%',
                            }}
                        >
                            <LabelSettings />
                        </TabPanel>
                        <TabPanel
                            style={{
                                width: '100%',
                            }}
                        >
                            <ContactInfo
                                style={{
                                    marginTop: 'auto',
                                    marginBottom: '10px',
                                    flexShrink: '0',
                                }}
                            />
                        </TabPanel>
                        <TabPanel
                            style={{
                                justifyContent: 'center',
                                flexDirection: 'row',
                                width: '100%'
                            }}
                        >
                            <ManualTab info={t('Get DRONonLine Manual')} name={t('_Manual')}/>
                        </TabPanel>
                    </SettingWrapper>
                </Tabs>
            </StyledWrapper>
        );
    }
}

const mapStateToProps: MapStateToProps<*, *, *> = state => ({
    userName: state.auth.get('userName'),
    userEmail: state.auth.get('userEmail')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    setChosenFlight,
    clearProject
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(WithAuth(User)));


// WEBPACK FOOTER //
// ./src/containers/content/grid/userWrapper/UserWrapper.jsx